import { axiosGet, axiosPost } from "../../../react_axios/Axios"
import {
    headers, insertHotelEnquiryDownloadUrl, insertHotelEnquiryUrl, getUserHotelEnquiryUrl, GET_USER_HOTEL_DETAILS, INSERT_HOTEL_FORM
} from "../../../utils/constants"



export const getUserHotelEnquiry_action = (exhID) => async (dispatch) => {
    try {
        const params = {
            UserId: sessionStorage.getItem('loginDataSS') != null && sessionStorage.getItem('loginDataSS') != undefined && sessionStorage.getItem('loginDataSS') != '' ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhRegistrationID: exhID,
            ExhVisitorID: JSON.parse(sessionStorage.getItem('VisitorDataSS')) != null ? JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID : null,
        }
        console.log("getExhibitorDashboard_action Action------->", params)

        const res = await axiosGet(getUserHotelEnquiryUrl, params, headers)

        dispatch({
            type: GET_USER_HOTEL_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}


export const insertHotelEnquiry_action = (exhID,
    Name,
    companyName,
    Email,
    finalMobNo,
    checkInDate,
    checkOutDate,
    NOP,
    NOR,
    singleOcc,
    doubleOcc,
    remark,) => async (dispatch) => {
        try {
            const mapdata = {
                UserId: sessionStorage.getItem('loginDataSS') != null && sessionStorage.getItem('loginDataSS') != undefined && sessionStorage.getItem('loginDataSS') != '' ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
                ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
                ExhRegistrationID: exhID,
                PersonName: Name,
                CompanyName: companyName,
                Email: Email,
                MobileNo: finalMobNo,
                CheckInDate: checkInDate,
                CheckOutDate: checkOutDate,
                NoofPax: NOP,
                NoofRooms: NOR,
                SingleOccupancy: singleOcc,
                DoubleOccupancy: doubleOcc,
                Remark: remark,
                ExhibitionName: sessionStorage.getItem("sessionExhibitionName"),
                ExhVisitorID: JSON.parse(sessionStorage.getItem('VisitorDataSS')) != null ? JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID : null,
            }
            console.log("Receiptentry-Action--------------------------->", mapdata)
            const res = await axiosPost(insertHotelEnquiryUrl, mapdata, headers);

            dispatch({
                type: INSERT_HOTEL_FORM,
                payload: res,
            })
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    }

